// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.btn::after {
  content: none !important;
  display: none !important;
}

.certificate-details-page {
  background: var(--background-gray, var(--light));
  box-sizing: border-box;
  flex: 1 1 auto;
  margin: 0 auto !important;
  max-width: 1920px !important;
  min-height: 0;
  overflow: auto;
  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;
  width: 96% !important;
}

.details-actions {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.65rem;
}

.details-actions__commands {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.details-actions__commands button {
  align-items: center;
  display: inline-flex;
  gap: 0.35rem;
}

.back-action {
  align-items: center;
  background: #fff !important;
  border: 1px solid var(--primary) !important;
  color: var(--primary) !important;
  display: inline-flex;
  gap: 0.5rem;
}

.back-action:hover, .back-action:focus-visible {
  background: var(--primary) !important;
  color: #fff !important;
}

.back-action mat-icon, .details-actions__commands mat-icon {
  font-size: 1.1rem;
  height: 1.1rem;
  width: 1.1rem;
}

.details-actions__commands .btn-outline-primary {
  background: #fff !important;
  border: 1px solid var(--primary) !important;
  color: var(--primary) !important;
}

.details-actions__commands .btn-outline-primary:hover,
.details-actions__commands .btn-outline-primary:focus,
.details-actions__commands .btn-outline-primary:focus-visible {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

.details-actions__commands .btn-outline-danger {
  background: #fff !important;
  border: 1px solid var(--danger) !important;
  color: var(--danger) !important;
}

.details-actions__commands .btn-outline-danger:hover,
.details-actions__commands .btn-outline-danger:focus,
.details-actions__commands .btn-outline-danger:focus-visible {
  background: var(--danger) !important;
  border-color: var(--danger) !important;
  color: #fff !important;
}

.certificate-header {
  align-items: center;
  background: #fff;
  background-image: none !important;
  border: 1px solid #dee2e6;
  border-left: 4px solid var(--primary);
  border-radius: 7px;
  color: var(--dark) !important;
  display: flex;
  margin: 0 0 1.1rem !important;
  min-height: 58px;
  padding: 0.9rem clamp(1rem, 3vw, 2rem);
}

.certificate-header::before,
.certificate-header::after {
  content: none !important;
  display: none !important;
}

.certificate-header h1 {
  color: var(--dark);
  font-size: clamp(1.3rem, 2vw, 1.65rem);
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
}

.eyebrow {
  color: var(--primary);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin: 0 0 0.2rem;
  text-transform: uppercase;
}

.details-panel {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  margin: 0 0 1rem;
  padding: 1.2rem;
}

.details-panel h2 {
  border-bottom: 1px solid #e9ecef;
  color: var(--dark);
  font-size: 1rem;
  margin: 0 0 1rem;
  padding-bottom: 0.7rem;
}

.certificate-fields {
  display: grid;
  gap: 1rem 1.4rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
}

.certificate-fields > div {
  min-width: 0;
}

.certificate-fields__wide {
  grid-column: 1/-1;
}

.certificate-fields dt {
  color: var(--secondary);
  font-size: 0.7rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
}

.certificate-fields dd {
  color: var(--dark);
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0;
  overflow-wrap: anywhere;
}

.preserve-lines {
  white-space: pre-wrap;
}

.attachment-panel {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.attachment-panel h2 {
  border: 0;
  margin-bottom: 0.5rem;
  padding: 0;
}

.attachment-name {
  align-items: center;
  display: flex;
  gap: 0.4rem;
  margin: 0;
  overflow-wrap: anywhere;
}

.attachment-name mat-icon {
  color: var(--primary);
}

.attachment-meta {
  color: var(--secondary);
  font-size: 0.78rem;
  margin: 0.35rem 0 0 1.5rem;
}

.attachment-panel > button {
  align-items: center;
  background: var(--primary) !important;
  border: 1px solid var(--primary) !important;
  color: #fff !important;
  display: inline-flex;
  gap: 0.4rem;
}

.attachment-panel > button:hover,
.attachment-panel > button:focus,
.attachment-panel > button:focus-visible {
  background: #0069d9 !important;
  border-color: #0069d9 !important;
  color: #fff !important;
}

.preview-panel h2 {
  margin-bottom: 0.8rem;
}

.document-preview__pdf {
  background: #f1f3f5;
  border: 1px solid #ced4da;
  display: block;
  height: min(78vh, 900px);
  min-height: 420px;
  width: 100%;
}

.document-preview__image {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  display: block;
  margin: 0 auto;
  max-height: 78vh;
  max-width: 100%;
  object-fit: contain;
}

.preview-unavailable {
  align-items: center;
  color: var(--secondary);
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.preview-unavailable p {
  margin: 0;
}

.preview-unavailable button {
  background: #fff !important;
  color: var(--primary) !important;
}

.state {
  align-items: center;
  border-radius: 4px;
  display: flex;
  gap: 0.65rem;
  margin: 0.7rem 0;
  padding: 0.7rem 0.9rem;
}

.state--error {
  background: color-mix(in srgb, var(--danger) 9%, white);
  border: 1px solid color-mix(in srgb, var(--danger) 35%, white);
  color: var(--danger);
}

.state--error span {
  flex: 1 1 auto;
}

@media (max-width: 700px) {
  .certificate-details-page {
    width: 100% !important;
  }
  .details-actions {
    align-items: flex-start;
    flex-direction: column;
  }
  .details-actions__commands {
    align-self: flex-end;
  }
  .certificate-fields {
    grid-template-columns: 1fr;
  }
  .certificate-fields__wide {
    grid-column: auto;
  }
  .attachment-panel {
    align-items: flex-start;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/yearly-calibration-certificates/yearly-calibration-certificate-details.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,wBAAA;EACA,wBAAA;AACF;;AAEA;EACE,gDAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,oDAAA;EACA,qBAAA;AACF;;AAEA;EAAmB,mBAAA;EAAqB,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,sBAAA;AAMlG;;AALA;EAA6B,mBAAA;EAAqB,aAAA;EAAe,WAAA;AAWjE;;AAVA;EAAoC,mBAAA;EAAqB,oBAAA;EAAsB,YAAA;AAgB/E;;AAfA;EAAe,mBAAA;EAAqB,2BAAA;EAA6B,2CAAA;EAA6C,gCAAA;EAAkC,oBAAA;EAAsB,WAAA;AAwBtK;;AAvBA;EAAiD,qCAAA;EAAuC,sBAAA;AA4BxF;;AA3BA;EAA6D,iBAAA;EAAmB,cAAA;EAAgB,aAAA;AAiChG;;AAhCA;EACE,2BAAA;EACA,2CAAA;EACA,gCAAA;AAmCF;;AAjCA;;;EAGE,qCAAA;EACA,uCAAA;EACA,sBAAA;AAoCF;;AAlCA;EACE,2BAAA;EACA,0CAAA;EACA,+BAAA;AAqCF;;AAnCA;;;EAGE,oCAAA;EACA,sCAAA;EACA,sBAAA;AAsCF;;AAnCA;EACE,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,yBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,sCAAA;AAsCF;;AApCA;;EAEE,wBAAA;EACA,wBAAA;AAuCF;;AArCA;EAAyB,kBAAA;EAAoB,sCAAA;EAAwC,gBAAA;EAAkB,iBAAA;EAAmB,SAAA;AA6C1H;;AA5CA;EAAW,qBAAA;EAAuB,iBAAA;EAAkB,gBAAA;EAAkB,sBAAA;EAAuB,kBAAA;EAAmB,yBAAA;AAqDhH;;AAnDA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;AA2DpG;;AA1DA;EAAoB,gCAAA;EAAkC,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;AAkE7G;;AAjEA;EAAsB,aAAA;EAAe,gBAAA;EAAkB,gDAAA;EAAkD,SAAA;AAwEzG;;AAvEA;EAA4B,YAAA;AA2E5B;;AA1EA;EAA4B,iBAAA;AA8E5B;;AA7EA;EAAyB,uBAAA;EAAyB,iBAAA;EAAkB,gBAAA;EAAkB,sBAAA;EAAuB,yBAAA;AAqF7G;;AApFA;EAAyB,kBAAA;EAAoB,iBAAA;EAAkB,gBAAA;EAAkB,SAAA;EAAW,uBAAA;AA4F5F;;AA3FA;EAAkB,qBAAA;AA+FlB;;AA7FA;EAAoB,mBAAA;EAAqB,aAAA;EAAe,8BAAA;EAAgC,SAAA;AAoGxF;;AAnGA;EAAuB,SAAA;EAAW,qBAAA;EAAsB,UAAA;AAyGxD;;AAxGA;EAAmB,mBAAA;EAAqB,aAAA;EAAe,WAAA;EAAY,SAAA;EAAW,uBAAA;AAgH9E;;AA/GA;EAA4B,qBAAA;AAmH5B;;AAlHA;EAAmB,uBAAA;EAAyB,kBAAA;EAAmB,0BAAA;AAwH/D;;AAvHA;EACE,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;AA0HF;;AAxHA;;;EAGE,8BAAA;EACA,gCAAA;EACA,sBAAA;AA2HF;;AAxHA;EAAoB,qBAAA;AA4HpB;;AA3HA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,wBAAA;EACA,iBAAA;EACA,WAAA;AA8HF;;AA5HA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA+HF;;AA7HA;EAAuB,mBAAA;EAAqB,uBAAA;EAAyB,aAAA;EAAe,eAAA;EAAiB,YAAA;AAqIrG;;AApIA;EAAyB,SAAA;AAwIzB;;AAvIA;EAA8B,2BAAA;EAA6B,gCAAA;AA4I3D;;AA1IA;EAAS,mBAAA;EAAqB,kBAAA;EAAoB,aAAA;EAAe,YAAA;EAAa,gBAAA;EAAiB,sBAAA;AAmJ/F;;AAlJA;EAAgB,uDAAA;EAAyD,8DAAA;EAAgE,oBAAA;AAwJzI;;AAvJA;EAAqB,cAAA;AA2JrB;;AAzJA;EACE;IAA4B,sBAAA;EA6J5B;EA5JA;IAAmB,uBAAA;IAAyB,sBAAA;EAgK5C;EA/JA;IAA6B,oBAAA;EAkK7B;EAjKA;IAAsB,0BAAA;EAoKtB;EAnKA;IAA4B,iBAAA;EAsK5B;EArKA;IAAoB,uBAAA;IAAyB,sBAAA;EAyK7C;AACF","sourcesContent":[":host {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.btn::after {\n  content: none !important;\n  display: none !important;\n}\n\n.certificate-details-page {\n  background: var(--background-gray, var(--light));\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  margin: 0 auto !important;\n  max-width: 1920px !important;\n  min-height: 0;\n  overflow: auto;\n  padding: .65rem clamp(.65rem, 2vw, 1.4rem) .75rem;\n  width: 96% !important;\n}\n\n.details-actions { align-items: center; display: flex; justify-content: space-between; gap: 1rem; margin-bottom: .65rem; }\n.details-actions__commands { align-items: center; display: flex; gap: .5rem; }\n.details-actions__commands button { align-items: center; display: inline-flex; gap: .35rem; }\n.back-action { align-items: center; background: #fff !important; border: 1px solid var(--primary) !important; color: var(--primary) !important; display: inline-flex; gap: .5rem; }\n.back-action:hover, .back-action:focus-visible { background: var(--primary) !important; color: #fff !important; }\n.back-action mat-icon, .details-actions__commands mat-icon { font-size: 1.1rem; height: 1.1rem; width: 1.1rem; }\n.details-actions__commands .btn-outline-primary {\n  background: #fff !important;\n  border: 1px solid var(--primary) !important;\n  color: var(--primary) !important;\n}\n.details-actions__commands .btn-outline-primary:hover,\n.details-actions__commands .btn-outline-primary:focus,\n.details-actions__commands .btn-outline-primary:focus-visible {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: #fff !important;\n}\n.details-actions__commands .btn-outline-danger {\n  background: #fff !important;\n  border: 1px solid var(--danger) !important;\n  color: var(--danger) !important;\n}\n.details-actions__commands .btn-outline-danger:hover,\n.details-actions__commands .btn-outline-danger:focus,\n.details-actions__commands .btn-outline-danger:focus-visible {\n  background: var(--danger) !important;\n  border-color: var(--danger) !important;\n  color: #fff !important;\n}\n\n.certificate-header {\n  align-items: center;\n  background: #fff;\n  background-image: none !important;\n  border: 1px solid #dee2e6;\n  border-left: 4px solid var(--primary);\n  border-radius: 7px;\n  color: var(--dark) !important;\n  display: flex;\n  margin: 0 0 1.1rem !important;\n  min-height: 58px;\n  padding: .9rem clamp(1rem, 3vw, 2rem);\n}\n.certificate-header::before,\n.certificate-header::after {\n  content: none !important;\n  display: none !important;\n}\n.certificate-header h1 { color: var(--dark); font-size: clamp(1.3rem, 2vw, 1.65rem); font-weight: 700; line-height: 1.15; margin: 0; }\n.eyebrow { color: var(--primary); font-size: .7rem; font-weight: 700; letter-spacing: .08em; margin: 0 0 .2rem; text-transform: uppercase; }\n\n.details-panel { background: #fff; border: 1px solid #dee2e6; border-radius: 5px; margin: 0 0 1rem; padding: 1.2rem; }\n.details-panel h2 { border-bottom: 1px solid #e9ecef; color: var(--dark); font-size: 1rem; margin: 0 0 1rem; padding-bottom: .7rem; }\n.certificate-fields { display: grid; gap: 1rem 1.4rem; grid-template-columns: repeat(2, minmax(0, 1fr)); margin: 0; }\n.certificate-fields > div { min-width: 0; }\n.certificate-fields__wide { grid-column: 1 / -1; }\n.certificate-fields dt { color: var(--secondary); font-size: .7rem; font-weight: 700; margin-bottom: .25rem; text-transform: uppercase; }\n.certificate-fields dd { color: var(--dark); font-size: .9rem; font-weight: 500; margin: 0; overflow-wrap: anywhere; }\n.preserve-lines { white-space: pre-wrap; }\n\n.attachment-panel { align-items: center; display: flex; justify-content: space-between; gap: 1rem; }\n.attachment-panel h2 { border: 0; margin-bottom: .5rem; padding: 0; }\n.attachment-name { align-items: center; display: flex; gap: .4rem; margin: 0; overflow-wrap: anywhere; }\n.attachment-name mat-icon { color: var(--primary); }\n.attachment-meta { color: var(--secondary); font-size: .78rem; margin: .35rem 0 0 1.5rem; }\n.attachment-panel > button {\n  align-items: center;\n  background: var(--primary) !important;\n  border: 1px solid var(--primary) !important;\n  color: #fff !important;\n  display: inline-flex;\n  gap: .4rem;\n}\n.attachment-panel > button:hover,\n.attachment-panel > button:focus,\n.attachment-panel > button:focus-visible {\n  background: #0069d9 !important;\n  border-color: #0069d9 !important;\n  color: #fff !important;\n}\n\n.preview-panel h2 { margin-bottom: .8rem; }\n.document-preview__pdf {\n  background: #f1f3f5;\n  border: 1px solid #ced4da;\n  display: block;\n  height: min(78vh, 900px);\n  min-height: 420px;\n  width: 100%;\n}\n.document-preview__image {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  display: block;\n  margin: 0 auto;\n  max-height: 78vh;\n  max-width: 100%;\n  object-fit: contain;\n}\n.preview-unavailable { align-items: center; color: var(--secondary); display: flex; flex-wrap: wrap; gap: .75rem; }\n.preview-unavailable p { margin: 0; }\n.preview-unavailable button { background: #fff !important; color: var(--primary) !important; }\n\n.state { align-items: center; border-radius: 4px; display: flex; gap: .65rem; margin: .7rem 0; padding: .7rem .9rem; }\n.state--error { background: color-mix(in srgb, var(--danger) 9%, white); border: 1px solid color-mix(in srgb, var(--danger) 35%, white); color: var(--danger); }\n.state--error span { flex: 1 1 auto; }\n\n@media (max-width: 700px) {\n  .certificate-details-page { width: 100% !important; }\n  .details-actions { align-items: flex-start; flex-direction: column; }\n  .details-actions__commands { align-self: flex-end; }\n  .certificate-fields { grid-template-columns: 1fr; }\n  .certificate-fields__wide { grid-column: auto; }\n  .attachment-panel { align-items: flex-start; flex-direction: column; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
